import React  from 'react';
import styled from 'styled-components';
import CUA    from '@assets/CUA.svg';

const Wrapper = styled.div`
  display         : flex;
  justify-content : center;
  align-items     : center;
  width           : 100%;
  height          : 100%;
`;

const Logo = styled(CUA)`
  margin-top    : 60px;
  width         : 360px;
  height        : 270px;
  opacity       : 0.15;
  border-radius : 20px;
`;

export const Loader = (): JSX.Element => (
  <Wrapper>
    <Logo  />
  </Wrapper>
);
